// 价格含有区间价/一口价/阶梯价
import * as React from 'react';
import { useAppSelector } from '../../redux/hooks';
import * as classnames from "classnames"
import './index.scss';

function ProductPrice ( props: any ) {
  const { price,i18n,moq,newBuyerActivityText } = props;
  if (!price) return null;

  // 区间价特殊逻辑，高亮
  const skuInfo = useAppSelector(state => state.sku.goods);
  const {quantity} = skuInfo;

  const renderPrice = () => {
    const { productLadderPrices,formatFixedPrice, unitEven,productRangePrices,unit, formatPromotionFixedPrice } = price;
    // 促销价格
    if (formatPromotionFixedPrice) {
      return <div className="promotion-price">
        <strong>{formatPromotionFixedPrice}</strong> 
        <span className="promotion-unit">/ {unit}</span>
        <span className="promotion-moq">{moq} {unitEven}</span>
        <span className="promotion-min">{i18n["detailRelatedProducts.minOrder"]}</span>
        <p>
          <del>{formatFixedPrice}</del>
        </p>
      </div>
    }
    // 区间价
    if ( productRangePrices ) {
      const { priceRangeText, pricePromotionRangeText } = productRangePrices;
      return <div className="price-range">
        {pricePromotionRangeText && <span className="promotion">{pricePromotionRangeText}</span>}
        {!pricePromotionRangeText && <span className="price">{priceRangeText}</span>}
        <span className="unit">/ {unit} |</span>
        <span className="moq">{moq} {unit}/{unitEven}</span>
        <span className="name">({i18n["marketAction.moqName"]})</span>
        {pricePromotionRangeText && <del>{priceRangeText}</del>}
      </div>;
    }

    // 阶梯价
    if ( productLadderPrices ) {
      return productLadderPrices.map( ( item: any,index: number ) => ( <div className="price-item" key={index}>
        {item.max === -1 ?
          <div className="quality">&gt;= {item.min} {unitEven}</div> :
          <div className="quality">{item.min} - {item.max} {unitEven}</div>}
        <div className="price">
          {item.formatPromotionPrice && <span className={classnames({
            'promotion': quantity <= moq && index === 0 ||  quantity >= item.min && quantity <= item.max || quantity >= item.min && item.max === -1
          })}>{item.formatPromotionPrice}</span>}
          {item.formatPromotionPrice && <span>{item.formatPrice}</span>}
          {!item.formatPromotionPrice && <span className={classnames({
            'promotion': quantity <= moq && index === 0 ||  quantity >= item.min && quantity <= item.max || quantity >= item.min && item.max === -1
          })}>{item.formatPrice}</span>}
        </div>
      </div> ) );
    }

    return <div className="promotion-price">
    <strong className='normal'>{formatFixedPrice}</strong> 
    <span className="promotion-unit">/ {unit}</span>
    <span className="promotion-moq">{moq} {unitEven}</span>
    <span className="promotion-min">{i18n["detailRelatedProducts.minOrder"]}</span>
  </div>
  };

  return (
    <div className={classnames({
      "product-price": true,
      "new-buyer": !!newBuyerActivityText
    })}>
      {newBuyerActivityText && <div className='new-buyer' dangerouslySetInnerHTML={{
        __html: newBuyerActivityText
      }} />}
      {renderPrice()}
    </div>
  );
}

export default ProductPrice;
